import { useState, useEffect, useRef } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Category = () => {
  const [ categories, setCategories ] = useState(null);
  const [ tableSearch, setTableSearch ] = useState('');
  const [ tableSortBy, setTableSortBy ] = useState('product_category_name');
  const [ tableSortType, setTableSortType ] = useState('ascending');
  const [ isLoadingPage, setIsLoadingPage ] = useState(true);
  const searchInputRef = useRef(null);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const requestCategories = {};
      const fetchCategories = await jwtFetch(config.ENDPOINT + 'get/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategories)
      });
      const responseCategories = await fetchCategories.json();
      if (responseCategories.status === 200) {
        for (let i in responseCategories.data) {
          let searchData = String(responseCategories.data[i].product_category_name ?? '').toLowerCase() + " ";
          responseCategories.data[i].search = searchData;
        }
        setCategories(responseCategories.data);
        setIsLoadingPage(false);
      } else {
        alert(responseCategories.message);
      }
    } catch (error) {
      console.error('Error in getCategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="category-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Product List</div>
                      <div className="btn-group" role="group">
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product'}><i className="bi bi-box me-1"/> Products</button>
                        <button className="btn bg-gold" type="button"><i className="bi bi-tag me-1"/> Categories</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product/category/subcategory'}><i className="bi bi-tags me-1"/> Subcategories</button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg"/> : <i className="bi bi-search"/>}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus/>
                      </div>
                      <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/product/category/add'}><i className="bi bi-plus-circle me-1"/> Add</button>
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {categories && categories.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer" onClick={() => sortTable('product_category_name')}>Name {tableSortBy === 'product_category_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('subcategories')}>Subcategories {tableSortBy === 'subcategories' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('products')}>Products {tableSortBy === 'products' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('product_category_status')}>Status {tableSortBy === 'product_category_status' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(categories, tableSortBy, tableSortType === 'ascending')
                            .filter(category => (category.search || '').includes((tableSearch || '').trim().toLowerCase()))
                            .map((category, c) => 
                              <tr key={"category-" + c}>
                                <td valign="middle">{c + 1}</td>
                                <td valign="middle">{category.product_category_name}</td>
                                <td valign="middle" align="center">{category.subcategories}</td>
                                <td valign="middle" align="center">{category.products}</td>
                                <td valign="middle" align="center"><span className={"badge bg-" + (category.product_category_status === 'Active' ? 'success' : 'danger')}>{category.product_category_status}</span></td>
                                <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/product/category/detail/' + category.id_product_category}><i className="bi bi-eye"/></button></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;


